import React from "react";

const Shimmer=()=>{
    return (
        <div className="flex flex-wrap justify-evenly">
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900 " data-testid="fakeItems"></div>
           
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>
            <div className="w-80 h-96 bg-pink-50 rounded-2xl m-4 shadow-2xl shadow-stone-900"></div>

        </div>
    )
}

export default Shimmer;



